import React from "react";
import products from "../../Assets/Images/products.png";
import picon1 from "../../Assets/Icons/picon1.png";
import picon2 from "../../Assets/Icons/picon2.png";
import Button from "../Inputs/Button";
import { useNavigate } from "react-router-dom";

const OurProducts = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-[#0E8A28] xl:h-[808px] py-10 flex-col sm:flex-row gap-6 flex-wrap pt-10 pb-14 flex ">
      <div className="flex-1 items-center  justify-center  flex">
        <div className="sm:min-w-[495.26px] bg-[rgba(73,164,93,0.31)] p-8 lg:p-10 2xl:p-12 !pb-0">
          <img
            src={products}
            className="object-cover w-full sm:w-[393.75px] h-full"
            alt=""
          />
        </div>
      </div>
      <div className="flex-1 pl-[8%] flex flex-col justify-center">
        <h3 className="font-[500] max-w-[503px] mb-[8px] sm:mb-[20px] text-[22px] sm:text-[44px] text-[#FFF]  sm:leading-[48px] ">
          Our products
        </h3>
        <h5 className="font-[400] max-w-[90%] sm:max-w-[424px] text-[14px] sm:text-[19.2px] mt-3 mb-10 sm:mt-4 sm:mb-16 text-[#FFF] sm:leading-[29px] ">
          At Greengate Pharmaceuticals Limited, we pride ourselves on our
          comprehensive range of healthcare products.
        </h5>

        <Button
          classes={"!bg-[#0E318A] !w-[193px]"}
          onClick={() => {
            navigate("/products");
          }}
          title={"View products"}
        />
        <div className="flex border-t mt-16 border-t-[rgba(255,255,255,0.39)] flex-wrap max-w-[90%] sm:max-w-[548px] justify-between gap-x-3 gap-y-7 py-12 sm:py-8 px-2">
          <div className="flex gap-2">
            <div className="bg-[rgba(255,255,255,0.28)] w-[60px] h-[60px] flex items-center justify-center p-2">
              <img src={picon1} className="w-[16px] h-[16px]" alt="" />
            </div>
            <div className=" max-w-[190px] ">
              <h3 className="font-[500] max-w-[503px] mb-2 text-[14px] sm:text-[16px] text-[#FFF]  ">
                Supplements
              </h3>
              <h3 className="font-[500]  text-[10px] sm:text-[11px] mt-2 text-[#FFF]  leading-[12px]">
                Boost your health with our high-quality supplements.
              </h3>
            </div>
          </div>
          <div className="flex gap-2">
            <div className="bg-[rgba(255,255,255,0.28)] w-[60px] h-[60px] flex items-center justify-center">
              <img src={picon2} className="w-[18px] h-[18px]" alt="" />
            </div>
            <div className=" max-w-[190px] ">
              <h3 className="font-[500] max-w-[503px] mb-2 text-[14px] sm:text-[16px] text-[#FFF]  ">
                Anti-fungal
              </h3>
              <h3 className="font-[500]  text-[10px] sm:text-[11px] mt-2 text-[#FFF]  leading-[12px]">
                Effective solutions for fungal infections.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurProducts;
